// =============================================================================
// components/NotificationBell.js — Header bildirim ikonu (Faz G)
// =============================================================================
// Header'da çan ikonu + badge (kaç yeni alert). Tıklayınca popup'ta liste.
// Her 60 sn'de bir refresh.
// =============================================================================

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  IconButton, Badge, Menu, MenuItem, Box, Typography, Divider, Chip, Stack
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { getAdminNotifications } from "../services/api";

const SEV_COLOR = { error: '#fef2f2', warning: '#fffbeb', success: '#f0fdf4', info: '#eff6ff' };
const SEV_BORDER = { error: '#ef4444', warning: '#f59e0b', success: '#10b981', info: '#3b82f6' };

export default function NotificationBell() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const load = useCallback(() => {
    getAdminNotifications()
      .then(r => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const click = (e) => setAnchorEl(e.currentTarget);
  const close = () => setAnchorEl(null);

  const goLink = (link) => {
    close();
    if (link) navigate(link);
  };

  const errorCount = items.filter(i => i.severity === 'error').length;
  const warnCount = items.filter(i => i.severity === 'warning').length;
  const infoCount = items.filter(i => i.severity === 'info').length;

  return (
    <>
      <IconButton color="inherit" onClick={click}>
        <Badge badgeContent={items.length} color={errorCount > 0 ? 'error' : warnCount > 0 ? 'warning' : 'primary'}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        PaperProps={{ sx: { width: 380, maxHeight: 500 } }}
      >
        <Box sx={{ p: 2, borderBottom: '1px solid #e2e8f0' }}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="subtitle1" fontWeight={700}>Bildirimler</Typography>
            <Stack direction="row" spacing={0.5}>
              {errorCount > 0 && <Chip label={errorCount} size="small" color="error" />}
              {warnCount > 0 && <Chip label={warnCount} size="small" color="warning" />}
              {infoCount > 0 && <Chip label={infoCount} size="small" color="info" />}
            </Stack>
          </Stack>
        </Box>
        {items.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography color="text.secondary" variant="body2">Aktif bildirim yok ✅</Typography>
          </Box>
        ) : items.slice(0, 12).map((n, i) => (
          <MenuItem
            key={i}
            onClick={() => goLink(n.link)}
            sx={{
              borderLeft: `3px solid ${SEV_BORDER[n.severity] || '#94a3b8'}`,
              bgcolor: SEV_COLOR[n.severity] || 'inherit',
              py: 1.5,
              whiteSpace: 'normal'
            }}
          >
            <Box>
              <Typography variant="body2" fontWeight={600}>{n.title}</Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                {n.body}
              </Typography>
            </Box>
          </MenuItem>
        ))}
        {items.length > 12 && (
          <>
            <Divider />
            <MenuItem onClick={() => goLink('/dashboard-v2')}>
              <Typography variant="caption" color="primary">
                +{items.length - 12} daha — Yönetim Merkezi'nde tümünü gör
              </Typography>
            </MenuItem>
          </>
        )}
      </Menu>
    </>
  );
}
